import React from 'react';

import Pagination from 'Components/Pagination';
import RowsSelector from 'Components/RowsSelector';
import EmptyList from 'Components/EmptyList';
import FiltersSection from './FiltersSection';
import TableHeader from './TableHeader';
import Row from './Row';
import {Input, inputStyleClasses} from 'Components/Input';

const SEARCHABLE_FIELDS = ['baseOilNumber', 'baseFormulaBaseOilNumber', 'formulatorNumber'];

export default class FormulasList extends React.Component {
  defaultState = {
    activePage: 1,
    selectedRowsCount: 10,
    applicationStatus: 'All',
    selectedType: 'All',
    sortedBy: 'baseOilNumber',
    sortAsc: -1,
    filter: {},
    searchString:'',
  };

  constructor(props) {
    super(props);

    const storedState = props.user.getStoredState('formulaListState', this.defaultState);
    props.user.updateURLSearchString(storedState);

    this.state = {
      ...this.defaultState,
      ...storedState
    };
  }

  componentWillUnmount() {
    const {user} = this.props;

    user.saveState('formulaListState', this.state, []);
  }

  handleRowsSelect = (rowsCountSelected, totalRowsCount) => {
    const {user} = this.props;

    const selectedRowsCount = (rowsCountSelected && rowsCountSelected < totalRowsCount) ? rowsCountSelected : 0;

    const state = {selectedRowsCount, activePage: 1};
    this.setState(state, user.updateURLSearchString(state));
  };

  handleActivePageChange = activePage => {
    const {user} = this.props;

    this.setState({activePage}, () => {user.updateURLSearchString({activePage});});
  };

  _filterList = componentList => {
    const {filter, searchString} = this.state;

    const doesSearchableFieldsContainSearchString = (element) => {
      for (let searchableFieldIndex in SEARCHABLE_FIELDS) {
        if (element[SEARCHABLE_FIELDS[searchableFieldIndex]]) {
          if (element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase()
            .includes(searchString.toLowerCase())) return true;
        }
      }
      return false;
    };

    return componentList.filter(element => {
      for (let filterFieldName in filter) {
        if (element[filterFieldName] !== filter[filterFieldName]) return false;
      }
      return (!searchString || doesSearchableFieldsContainSearchString(element));
    });
  };

  _sortList = (a, b) => {
    const {sortedBy, sortAsc} = this.state;

    switch (sortedBy) {
      case 'isPaid':
      case 'isReadAcrossFormula':
        return a[sortedBy] > b[sortedBy] ? sortAsc : -sortAsc;
      default:
        if (a[sortedBy] && b[sortedBy]) return a[sortedBy].toString().toLowerCase().replace(/\s+/g, ' ') > b[sortedBy].toString().toLowerCase().replace(/\s+/g, ' ') ? sortAsc : -sortAsc;
        else return a[sortedBy] > b[sortedBy] ? sortAsc : -sortAsc;
    }
  };

  handleSort = sortedBy => () => {
    const {user} = this.props;

    this.setState(prevState => ({sortedBy, sortAsc: -prevState.sortAsc, activePage: 1}), () => {
      user.updateURLSearchString({sortedBy: this.state.sortedBy, sortAsc: this.state.sortAsc, activePage: 1});
    });
  };

  handleSelectFilter = filterFieldName => filterElement => {
    const {user} = this.props;
    const newFilterFieldValue = filterElement.value !== undefined ? filterElement.value : filterElement;
    let newFilterState = this.state.filter;

    if (newFilterFieldValue === 'All') delete newFilterState[filterFieldName];
    else newFilterState[filterFieldName] = newFilterFieldValue;

    this.setState({filter: newFilterState, activePage: 1},
      () => {
        user.updateURLSearchString({filter: this.state.filter, activePage: 1});
      }
    );
  };

  handleSearchStringInput = value => {
    const {user} = this.props;
    this.setState({searchString:value, activePage:1}, () => {user.updateURLSearchString({searchString:value});});
  };

  _getList = () => {
    const {user, listRequestInProgress, formulasList, getAvailableActionsListBasedOnStatusAndYear} = this.props;
    const {activePage, selectedRowsCount, sortedBy} = this.state;

    let resultList = [];
    let resultLength = 0;

    if (!formulasList.length) {
      if (listRequestInProgress) {
        resultList = [
          <div key="spinner" className='ect-spinner _height_120'>
            <div className='ect-spinner__image'  style={{width: 50, height: 50}} />
          </div>
        ];
      } else {
        resultList = [
          <EmptyList key="empty">
            No formulas for selected manufacturer.
          </EmptyList>
        ];
      }
    } else {
      const filteredList = this._filterList(formulasList).sort(this._sortList);
      const sliceFrom = (activePage - 1) * selectedRowsCount;
      const sliceTo = +selectedRowsCount ? activePage * selectedRowsCount : filteredList.length;

      if (!filteredList.length) {
        resultList = [
          <EmptyList key="empty">
            No formulas found with selected filters.
          </EmptyList>
        ];
      } else {
        resultList = filteredList.slice(sliceFrom, sliceTo).map((formula, index) => {
          return (
            <Row
              key={formula.id}
              user={user}
              formula={formula}
              isOdd={!!(index % 2)}
              sortedBy={sortedBy}
              availableActionsList={getAvailableActionsListBasedOnStatusAndYear(
                formula.applicationStatus,
                8000,
                formula.id,
                undefined,
                formula.isPaid
              )}
            />
          );
        });
        resultLength = filteredList.length;
      }
    }

    return {
      resultList,
      resultLength
    };
  };

  render() {
    const {engineTypes} = this.props;
    const {activePage, selectedRowsCount, sortedBy, sortAsc, filter, searchString} = this.state;
    const {resultList, resultLength} = this._getList();

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper list-scene__content-wrapper'>
          <header className='scene__scene-header list-scene__scene-header'>
            Formulation List
            <Input
              mainWrapperClassName='list-scene__header-search-field-wrapper'
              styleClass={inputStyleClasses.searchBar}
              placeholder='Type here to search'
              maxLength={250}
              value={searchString}
              onChange={this.handleSearchStringInput}
            />
          </header>
          <FiltersSection
            outCount={resultLength}
            handleRowCountSelect={this.handleRowsSelect}
            rowsCount={selectedRowsCount}
            handleSelectFilter={this.handleSelectFilter}
            filterState={filter}
            engineTypes={engineTypes}
          />
          <TableHeader handleSortClick={this.handleSort} order={sortAsc === 1} sortedBy={sortedBy} />

          {resultList}

          <footer className='list-scene__footer'>
            <RowsSelector
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
              handleRowsSelect={this.handleRowsSelect}
            />
            <Pagination
              className='_height_80'
              activePage={activePage}
              handleClick={this.handleActivePageChange}
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
            />
          </footer>
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/List/index.jsx